var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75,4.3C36,4.3,4.3,36,4.3,75s31.6,70.7,70.7,70.7,70.7-31.6,70.7-70.7S114,4.3,75,4.3ZM75.9,133.1c-32.1,0-58.1-26-58.1-58.1s26-58.1,58.1-58.1,58.1,26,58.1,58.1-26,58.1-58.1,58.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.5,76.2v.3c0,4.3-3.5,7.9-7.9,7.9h-46.3l7.4,6.7c3.3,3,3.5,8.1.6,11.3-1.6,1.8-3.8,2.6-6,2.6s-3.8-.7-5.4-2c-3.6-3.3-7.3-6.5-10.9-9.8-3.6-3.3-7.3-6.6-10.9-9.8-.3-.2-.8-.6-1.2-1-.3-.3-.8-.9-1.3-1.7-.7-1.2-1.1-2.6-1.1-4,0-2.1.8-4.1,2.3-5.7l22.7-22.7c3.1-3.1,8.2-3.1,11.3,0s2.3,3.6,2.3,5.7-.8,4.1-2.3,5.7l-8.7,8.7h47.3c4.3,0,7.9,3.5,7.9,7.9Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowIcon);
export default __webpack_public_path__ + "static/media/left_arrow_icon.2f41c8841791dfd138d998b254356128.svg";
export { ForwardRef as ReactComponent };